import React, { useState } from 'react';
import './Contact.css';

const Contact: React.FC = () => {
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    company: '',
    message: '',
  });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitted(true);
  };

  return (
    <section className="contact" id="contact">
      <div className="contact__container">
        <div className="contact__left">
          <span className="contact__tag">Contact</span>
          <h2 className="contact__title">
            Let's Talk About<br />
            <span className="contact__title--accent">Your Hiring Needs</span>
          </h2>
          <p className="contact__desc">
            Drop us a message and we'll get back to you within a day.
          </p>
          <div className="contact__benefits">
            <div className="contact__benefit">
              <span className="contact__benefit-check">✓</span>
              Free consultation — no obligations
            </div>
            <div className="contact__benefit">
              <span className="contact__benefit-check">✓</span>
              Pre-vetted candidates only
            </div>
            <div className="contact__benefit">
              <span className="contact__benefit-check">✓</span>
              Transparent pricing, no hidden fees
            </div>
            <div className="contact__benefit">
              <span className="contact__benefit-check">✓</span>
              Replacement guarantee included
            </div>
          </div>
        </div>
        <div className="contact__right">
          {submitted ? (
            <div className="contact__success">
              <div className="contact__success-icon">✓</div>
              <h3 className="contact__success-title">Message Sent!</h3>
              <p className="contact__success-text">
                Thank you, {formData.fullName}. Our team will reach out to you within 24 hours.
              </p>
            </div>
          ) : (
            <form className="contact__form" onSubmit={handleSubmit}>
              <div className="contact__field">
                <label className="contact__label" htmlFor="fullName">Full Name</label>
                <input
                  className="contact__input"
                  type="text"
                  id="fullName"
                  name="fullName"
                  placeholder="John Doe"
                  value={formData.fullName}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="contact__field">
                <label className="contact__label" htmlFor="email">Email</label>
                <input
                  className="contact__input"
                  type="email"
                  id="email"
                  name="email"
                  placeholder="john@company.com"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="contact__field">
                <label className="contact__label" htmlFor="company">Company</label>
                <input
                  className="contact__input"
                  type="text"
                  id="company"
                  name="company"
                  placeholder="Acme Inc."
                  value={formData.company}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="contact__field">
                <label className="contact__label" htmlFor="message">Message</label>
                <textarea
                  className="contact__textarea"
                  id="message"
                  name="message"
                  placeholder="Tell us about the roles you need to fill..."
                  rows={4}
                  value={formData.message}
                  onChange={handleChange}
                  required
                />
              </div>
              <button className="contact__submit" type="submit">
                Send Message
                <span className="contact__submit-arrow">→</span>
              </button>
            </form>
          )}
        </div>
      </div>
    </section>
  );
};

export default Contact;
